exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nspan.item{\n  font-weight: bold;\n  min-width: 100px;\n  width: 100px;\n  display: inline-block;\n  letter-spacing: 2px;\n}\ndiv.info{\n  margin: 15px 5px;\n  border-bottom: 1px solid #eee;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-61397f3a","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/mall/trade/shengyibao.vue
// module id = 1528
// module chunks = 0